import ADIColors from "@NA/Utils/ADIColors";
import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import { IconWrapper } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { css } from "styled-components";
import ADILiveChatComponent from "../ADILiveChatComponent";
import { StyledButton } from "@insite/mobius/Clickable";

interface OwnProps {
    quoteDetails: OrderModel | undefined;
    isLogicBrokerModalOpen: boolean;
    closeModalLogicBroker: () => void;
    AgreeAndContinueCheckout: (url: string, customerOrderId: string) => void;
}

type Props = OwnProps;

export interface ADILogicBrokerModalStyles {
    logicBrokerModal?: ModalPresentationProps;
    logicBrokerTitleTypography?: InjectableCss;
    logicBrokerTableContainer?: GridContainerProps;
    logicBrokerTableHeader?: GridItemProps;
    logicBrokerTableBody?: GridItemProps;
    logicBrokerTableLi?: GridItemProps;
    logicBrokerTitleTypographyAcknowledgement?: InjectableCss;
    logicBrokerPolicyContainer?: GridContainerProps;
    logicBrokerPolicyTitle?: InjectableCss;
    logicBrokerPolicyPara?: InjectableCss;
    logicBrokerActionContainer?: GridContainerProps;
    logicBrokerActionContainerGridItem?: GridItemProps;
    logicBrokerAgreeButton?: ButtonPresentationProps;
    logicBrokerEditCarBtutton?: ButtonPresentationProps;
    logicBrokerRemoveItemsLink?: LinkPresentationProps;
}

export const adiLogicBrokerModalStyles: ADILogicBrokerModalStyles = {
    logicBrokerActionContainer: {
        offsetCss: css`
            width: 100% !important;
            margin: auto;
        `,
    },
    logicBrokerActionContainerGridItem: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            align-items: center;
            flex-direction: row;
            justify-content: flex-end;
            padding-bottom: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    flex-wrap: wrap;
                    flex-direction: column-reverse;
                    gap: 18px;
                    align-items: center;
                    justify-content: center;
                    padding-bottom: 0px;
                `,
                    css`
                    flex-wrap: wrap;
                    flex-direction: column-reverse;
                    gap: 18px;
                    align-items: center;
                    justify-content: center;
                    padding-bottom: 0px;
                `,
                    null,
                    null,
                    null,
                ])}
            
        `,
    },
    logicBrokerAgreeButton: {
        css: css`
            min-width: 192px;
            height: 42px;
            margin: 0 0 0 15px;
            border-radius: 4px;
            padding: 0 16px;
            font-size: 14px;
            font-weight: 800;
            text-align: center;
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css` margin: 0; `,
                css` margin: 0; `,
                null,
                null,
                null,
            ])}
            
        `,
    },
    logicBrokerEditCarBtutton: {
        css: css`
            min-width: initial;
            height: 42px;
            font-size: 14px;
            font-weight: 600;
            padding: 0 16px;
            text-align: center;
            border-radius: 4px;
            margin: 0;
            &:hover{
                background: ${ADIColors.darkBlue6} !important;
                color: ${ADIColors.blue1} !important;
            }
        `,
    },
    logicBrokerRemoveItemsLink: {
        css: css`
            font-size: 14px;
            font-weight: bold;
        `,
    },
    logicBrokerPolicyTitle: {
        css: css`
            color: ${getColor("secondary")};
            justify-content: center;
            font-weight: 900;
            font-stretch: normal;
            font-style: normal;
            line-height: 36px;
            letter-spacing: normal;
            color: ${ADIColors.darkBlue1};
            border: 0;
            margin-top: 0;
            padding-bottom: 0;
            font-size: 20px !important;
            text-align: center;
            margin-bottom: 15px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: center;
                    `,
                    css`
                        text-align: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    logicBrokerPolicyPara: {
        css: css`
            font-size: 12px;
            display: inline;
            margin-bottom: 1rem !important;
            padding: 0px 15px;
        `,
    },
    logicBrokerPolicyContainer: {
        offsetCss: css`
            width: 100% !important;
            margin: auto;
            border: 1px solid ${getColor("common.border")};
            max-height: 209px;
            overflow-y: scroll;
            margin-bottom: 20px;
            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-track {
                background: ${getColor("common.background")};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${getColor("text.accent")};
                border-radius: 7px;
            }
            > * {
                flex-basis: 100%;
                max-width: 100%;
            }
        `,
    },
    logicBrokerTitleTypographyAcknowledgement: {
        css: css`
            margin: 1rem 0rem;
            line-height: inherit;
            font-size: 16px;
            line-height: 24px;
            color: ${ADIColors.black};
            margin-bottom: 3px;
            font-weight: 400;
            ${StyledButton}{
                color: ${ADIColors.blue5};
                text-decoration: underline;
                &:hover {
                    color: ${ADIColors.blue1};
                }
            }
            ${TypographyStyle} {
                font-size: 16px;
                line-height: 24px;
                color: ${ADIColors.blue5};
                text-decoration: underline;
                font-weight: 400;
                &:hover {
                    color: ${ADIColors.blue1};
                }
            }
            
        `,
    },
    logicBrokerTableLi: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            padding: 10px 20px;
            align-items: center;
            font-size: 16px!important;
            -webkit-text-size-adjust:100%;
            color: ${ADIColors.black};
            &:nth-child(even) {
                background: ${ADIColors.gray27};
            }
            &:nth-child(odd) {
                background: ${getColor("text.disabled")};
            }
            > ${TypographyStyle}:first-child {
                width: 20%;
            }
            > ${TypographyStyle}:nth-child(2) {
                width: 25%;
            }
            > ${TypographyStyle}:last-child {
                width: 55%;
            }
        `,
    },
    logicBrokerTableBody: {
        css: css`
            border: 1px solid ${getColor("common.border")};
        `,
    },
    logicBrokerTableHeader: {
        css: css`
            font-size: 16px;
            font-weight: bold;
            -webkit-text-size-adjust:100%;
            color: ${ADIColors.black};
            > ${TypographyStyle}:first-child {
                width: 20%;
            }
            > ${TypographyStyle}:nth-child(2) {
                width: 25%;
            }
            > ${TypographyStyle}:last-child {
                width: 55%;
            }
        `,
    },
    logicBrokerTableContainer: {
        css: css`
            overflow: auto;
        `,
        offsetCss: css`
            margin: auto;
            flex-basis: 100%;
            max-width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 1470px !important;
                        max-width: 1470px;
                    `,
                    css`
                        width: 1470px !important;
                        max-width: 1470px;
                    `,
                    null,
                    null,
                    null,
                ])}
            > ${GridItemStyle}:first-child {
                flex-basis: 100%;
                max-width: 100%;
                padding: 10px 20px;
            }
            > ${GridItemStyle}:last-child {
                flex-basis: 100%;
                max-width: 100%;
                flex-direction: column;
                padding: 0px;
                align-items: unset;
            }
        `,
    },
    logicBrokerTitleTypography: {
        css: css`
            line-height: inherit;
            font-size: 18px;
            line-height: 24px;
            color: ${ADIColors.black};
            margin-bottom: 9px;
            font-weight: 700;
        `,
    },
    logicBrokerModal: {
        headlineTypographyProps: {
            variant: "h2",
            css: css`
                font-size: 34px;
                font-weight: 900;
                font-stretch: normal;
                font-style: normal;
                line-height: 36px;
                letter-spacing: normal;
                color: ${ADIColors.darkBlue1};
                border: 0;
                margin-top: 0;
                margin-bottom: 10px;
                padding-bottom: 0;
            `,
        },
        closeButtonProps: {
            css: css`
                padding: 0;
                position: relative;
                margin-top: -30px;
                margin-right: -20px;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css` margin-right: -5px; `,
                        css` margin-right: -5px; `,
                        css` margin-right: -15px; `,
                        css` margin-right: -20px; `,
                        css` margin-right: -20px; `,
                    ]);
                }}
                &:hover {
                    background: transparent;
                    border-color: transparent;
                }
                > ${IconWrapper} {
                    color: ${getColor("primary")};
                    width: 35px;
                    height: 35px;
                    > svg {
                        width: 35px;
                        height: 35px;
                        stroke-width: 1px;
                    }
                }
            `,
        },
        cssOverrides: {
            modalContainer: css`
                > div[class^="ContentBody"] {
                    padding-bottom: 20px;
                }
            `,
            modalBody: css`
                border-radius: 7px;
                overflow: auto;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css`
                            max-width: calc(100% - 20px);
                            padding-bottom: 20px;
                            top: 85px;
                            height: auto;
                            position: absolute; 
                            max-height: 80%;
                            overflow: auto; 
                            top: auto;
                            max-height: 90vh;               
                        `,
                        css`
                            top: 85px;
                            max-width: calc(100% - 20px);
                            border-radius: 6px;
                            padding-bottom: 20px;
                            height: auto;
                            position: absolute;
                            max-height: 80%;
                            overflow: auto; 
                            top: auto;
                            max-height: 90vh; 
                        `,
                        css`
                            max-width: 95%;
                            top: auto;
                            height: auto;
                            position: absolute;
                            max-height: calc(100% - 30%)
                        `,
                        css`
                            max-width: 562px;
                            top: 13%;
                            height: auto;
                            position: absolute;
                            max-height: calc(100% - 30%) 
                        `,
                        css`
                            max-width: 1016px;
                            top: 15%;
                            margin: 0 auto;
                            height: auto;
                            position: absolute;
                            max-height: calc(100% - 30%)
                        `,
                    ]);
                }}
                ${GridWrapper} {
                    max-width: 100%;
                }
            `,

            modalContent: css`
                padding: 0px 30px;
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css` padding: 0px 8px; `,
                        css` padding: 0px 8px; `,
                        css` padding: 0px 36px 8px 28px; `,
                        css` padding: 0px 30px; `,
                        css` padding: 0px 30px; `,
                    ]);
                }}
            `,

            modalTitle: css`
                border-bottom: unset;
                padding: 28px 30px 18px;
                > ${TypographyStyle} {
                    font-size: 28px;
                    font-weight: 700;
                    text-align: left;
                    line-height: normal;
                    ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css` font-size: 24px; `,
                        css` font-size: 24px; `,
                        css` font-size: 28px; `,
                        css` font-size: 28px; `,
                        css` font-size: 28px; `,
                    ]);
                }}
                }
                ${({ theme }) => {
                    return breakpointMediaQueries(theme, [
                        css` padding: 20px 10px 12px; `,
                        css` padding: 20px 10px 12px; `,
                        css` padding: 28px 36px 15px 28px; `,
                        css` padding: 28px 30px 18px `,
                        css` padding: 28px 30px 18px `,
                    ]);
                }}
            `,
        },
    },
};

const styles = adiLogicBrokerModalStyles;

const ADILogicBrokerModal: FC<Props> = ({
    isLogicBrokerModalOpen,
    closeModalLogicBroker,
    quoteDetails,
    AgreeAndContinueCheckout,
}) => {
    return (
        <Modal
            isOpen={isLogicBrokerModalOpen}
            handleClose={closeModalLogicBroker}
            headline="Shipping Required for Your Entire Order"
            sizeVariant="large"
            {...styles.logicBrokerModal}
        >
            <Typography variant="h3" {...styles.logicBrokerTitleTypography}>
                {translate("Your quote contains item(s) that are shipped by a third-party.")}
            </Typography>
            <GridContainer {...styles.logicBrokerTableContainer}>
                <GridItem {...styles.logicBrokerTableHeader}>
                    <Typography> {translate("ADI Part #")}</Typography>
                    <Typography>{translate("Manufacturer Part #")}</Typography>
                    <Typography>{translate("Description")}</Typography>
                </GridItem>
                <GridItem {...styles.logicBrokerTableBody}>
                    {quoteDetails?.orderLines?.map((item: any, index: number) => {
                        return (
                            <>
                                {(item?.properties?.logicBroker?.toLowerCase() === 'yes' && Number(item.qtyOrdered) !== 0) && <GridItem
                                    as="li"
                                    {...styles.logicBrokerTableLi}
                                    key={`logicBroker-${index}`}
                                >
                                    <Typography>{item?.productErpNumber}</Typography>
                                    <Typography>{item?.properties['modelNumber']}</Typography>
                                    <Typography>{item?.properties['longDescription'] || item?.properties['shortDescription']}</Typography>
                                </GridItem>}
                            </>
                        );
                    })}
                </GridItem>
            </GridContainer>
            <Typography variant="p" {...styles.logicBrokerTitleTypographyAcknowledgement}>
                {translate('As a result, your entire order must be shipped and cannot be collected from a branch. Please contact ADI at')} <Link href="tel:1.877.228.6739">{translate("1.877.228.6739")}</Link> {translate('or')} <ADILiveChatComponent isFooter={true} /> {translate('for further information regarding your quote.')}
            </Typography>

            <GridContainer {...styles.logicBrokerActionContainer}>
                <GridItem {...styles.logicBrokerActionContainerGridItem}>
                    <Button variant="secondary" {...styles.logicBrokerEditCarBtutton}
                        onClick={closeModalLogicBroker}
                    >
                        {translate("Cancel")}
                    </Button>
                    <Button
                        {...styles.logicBrokerAgreeButton}
                        onClick={() => AgreeAndContinueCheckout('/Checkout/ReviewAndPay?cartId=', `${quoteDetails?.insiteCustomerOrderId}`)}
                    >
                        {translate("Continue to Checkout")}
                    </Button>
                </GridItem>
            </GridContainer>
        </Modal>
    )
};

export default ADILogicBrokerModal;